import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search as SearchIcon, SlidersHorizontal } from "lucide-react";

const SearchBar = ({ initialValue = "", autoNavigate = true, onSubmit }) => {
  const navigate = useNavigate();
  const [q, setQ] = useState(initialValue);

  const submit = (e) => {
    e.preventDefault();
    const trimmed = q.trim();
    if (onSubmit) {
      onSubmit(trimmed);
      return;
    }
    if (!autoNavigate) return;
    navigate(trimmed ? `/search?q=${encodeURIComponent(trimmed)}` : "/search");
  };

  return (
    <form
      onSubmit={submit}
      data-testid="premium-search-bar"
      className="w-full"
    >
      <div className="flex items-center gap-2 border border-gray-200 bg-white px-4 py-3 shadow-[0_2px_10px_rgba(0,0,0,0.04)] transition-colors focus-within:border-black">
        <SearchIcon className="h-5 w-5 text-gray-500" />
        <input
          data-testid="premium-search-input"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Search Royal Lady…"
          className="w-full border-0 bg-transparent text-sm text-black outline-none placeholder:text-gray-400"
        />
        <button
          type="button"
          onClick={() => navigate("/search")}
          data-testid="premium-search-filter-btn"
          className="grid h-8 w-8 place-items-center border-l border-gray-200 pl-2 text-gray-500 hover:text-black"
          aria-label="Filters"
        >
          <SlidersHorizontal className="h-4 w-4" />
        </button>
      </div>
    </form>
  );
};

export default SearchBar;
